import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const adp = defineConnector({
  identifier: "adp",
  name: "ADP",
  tagLine: "Payroll and HR management",
  keywords:
    "automatic data processing payroll hr hris workforce now workers benefits",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ adpDomain }) => urlToPattern(adpDomain),
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: app.config.tokenEndpoint,
        method: "POST",
        formBody: { grant_type: "client_credentials" },
        basicAuth: {
          username: app.secret.clientId,
          password: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create API credentials in ADP",
      items: [
        {
          kind: "markdown",
          content: `1. In the ADP developer portal, register your application
2. Note the **Client ID** and **Client Secret**
3. Download the PEM-encoded **client certificate** and **private key**`,
        },
      ],
    },
    {
      title: "Enter your ADP details",
      items: [
        {
          kind: "baseUrl",
          label: "ADP API base URL",
          required: true,
          placeholder: "https://api.adp.com",
          target: { kind: "configuration", field: "adpDomain" },
        },
        {
          kind: "baseUrl",
          label: "OAuth token URL",
          required: true,
          placeholder: "https://accounts.adp.com/auth/oauth/v2/token",
          target: { kind: "configuration", field: "tokenEndpoint" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
        {
          kind: "file",
          label: "Client certificate with chain",
          accept: ".pem,.crt,.cer",
          helperText:
            "The PEM-encoded certificate with chain issued by ADP. 3B presents it during every ADP request, including the OAuth token exchange.",
          target: { kind: "configuration", field: "clientCertificate" },
        },
        {
          kind: "file",
          label: "Client private key",
          accept: ".pem,.key",
          helperText:
            "The PEM-encoded private key matching the client certificate. It is encrypted and used only inside 3B’s proxy.",
          target: { kind: "secrets", field: "clientPrivateKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ adpDomain }) => `${adpDomain}/hr/v2/workers?$top=1`,
  },
});
